import { API } from './api';
import { fetchData } from '@umu/umu-fetch';
import {
    IReceiveCertificateParams,
    ICommonResponse,
    IGetCertificateDetailParams,
    ISetCertificateSettingParams,
    ISetCertificatePermissionParams,
    IAiCertificateItem,
    IAiRecommendedCourseItem,
    ICaetResourceConfig,
    IGetCertificateSettingResponse,
    IPageParams,
    CertificatePermission,
    CertificateReceiveStatus,
    RecognizeObjectType,
    ICaetSwitchInfo,
} from '../interface/api';

import { SWITCH_STATUS } from '@umu/umu-types';

/**
 * 领取证书
 */
export const receiveCertificate = (params: IReceiveCertificateParams): Promise<ICommonResponse> => {
    return fetchData(API.RECEIVE_CERTIFICATE, params, {
        silent: true,
    }).then(
        (res: IResponse<{ status: SWITCH_STATUS }>) => {
            return {
                isSuccess: res.data?.status === SWITCH_STATUS.YES,
                message: res.error_message,
            };
        },
        () => {
            return {
                isSuccess: false,
                message: '',
            };
        },
    );
};

/**
 * 获取证书列表
 */
export const getCertificateList = (params: IPageParams): Promise<IList<IAiCertificateItem>> => {
    return fetchData(API.CERTIFICATE_LIST, params, {
        silent: true,
    }).then((res: IResponse<IList<IAiCertificateItem>>) => {
        return res?.data || [];
    });
};

/**
 * 获取推荐课程列表
 */
export const getRecommendedCourseList = (params: IPageParams): Promise<IList<IAiRecommendedCourseItem>> => {
    return fetchData(API.RECOMMENDED_COURSE_LIST, params, {
        silent: true,
    }).then((res: IResponse<IList<IAiRecommendedCourseItem>>) => {
        return res?.data || [];
    });
};

/**
 * 设置证书信息
 */
export const setCertificateSetting = (
    params: ISetCertificateSettingParams,
): Promise<ICommonResponse & { data: IGetCertificateSettingResponse }> => {
    return fetchData(API.SET_CERTIFICATE_SETTING, params, {
        silent: true,
    }).then(
        (res: IResponse<{ status: SWITCH_STATUS }>) => {
            return {
                isSuccess: res.error_code === 0,
                message: res.error_message,
                data: res.data || defaultCertificateSettingResponse,
            };
        },
        () => {
            return {
                isSuccess: false,
                message: '',
            };
        },
    );
};

/**
 * 设置证书权限
 */
export const setCertificatePermission = (params: ISetCertificatePermissionParams): Promise<ICommonResponse> => {
    return fetchData(API.SET_CERTIFICATE_PERMISSION, params, {
        silent: true,
    }).then(
        (res: IResponse<{ status: SWITCH_STATUS }>) => {
            return {
                isSuccess: res.data?.status === SWITCH_STATUS.YES,
                message: res.error_message,
            };
        },
        () => {
            return {
                isSuccess: false,
                message: '',
            };
        },
    );
};

/**
 * 获取证书详情
 */
export const defaultCertificateResponse: IAiCertificateItem = {
    id: '',
    umu_id: '',
    user_name: '',
    names: [],
    caet_number: '',
    obj_id: '',
    obj_type: RecognizeObjectType.COURSE,
    obj_info: {
        name: '',
        img: '',
        url: '',
        content_number: '',
        m_name: '',
        m_img: '',
        duration: '',
        purchase_link: '',
    },
    completion_ts: '',
    certificate_url: '',
    duration: '',
    permission: CertificatePermission.PUBLIC,
    receive_ts: '',
    receive_status: CertificateReceiveStatus.NOT_RECEIVED,
    switch: SWITCH_STATUS.NO,
    is_exist: SWITCH_STATUS.NO,
    is_bind: SWITCH_STATUS.NO,
};
export const getCertificateDetail = (params: IGetCertificateDetailParams): Promise<IAiCertificateItem> => {
    return fetchData(API.GET_CERTIFICATE, params, {
        silent: true,
    }).then(
        (res: IResponse<IAiCertificateItem>) => {
            return res?.data || defaultCertificateResponse;
        },
        () => {
            return defaultCertificateResponse;
        },
    );
};
/**
 * 获取资源对应的证书信息
 */
export const getResourceCertificate = (params: IGetCertificateDetailParams): Promise<IAiCertificateItem> => {
    return fetchData(API.GET_RESOURCE_CERTIFICATE, params, {
        silent: true,
    }).then(
        (res: IResponse<IAiCertificateItem>) => {
            return res?.data || defaultCertificateResponse;
        },
        () => {
            return defaultCertificateResponse;
        },
    );
};
/**
 * 获取证书配置信息
 */
const defaultCaetResourceConfig: ICaetResourceConfig = {
    is_show: SWITCH_STATUS.NO,
    is_bind: SWITCH_STATUS.NO,
    email: '',
    receive_status: CertificateReceiveStatus.NOT_RECEIVED,
};
export const getCaetResourceConfig = (params: IGetCertificateDetailParams): Promise<ICaetResourceConfig> => {
    return fetchData(API.GET_RESOURCE_CONFIG, params, {
        silent: true,
    }).then(
        (res: IResponse<ICaetResourceConfig>) => {
            return res?.data || defaultCaetResourceConfig;
        },
        () => {
            return defaultCaetResourceConfig;
        },
    );
};
/**
 * 获取证书设置信息
 */
export const defaultCertificateSettingResponse: IGetCertificateSettingResponse = {
    status: SWITCH_STATUS.NO,
    next_editable_time: '',
    user_name: '',
    email: '',
};
export const getCertificateSetting = (): Promise<IGetCertificateSettingResponse> => {
    return fetchData(
        API.GET_CERTIFICATE_SETTING,
        {},
        {
            silent: true,
        },
    ).then(
        (res: IResponse<IGetCertificateSettingResponse>) => {
            return res?.data || defaultCertificateSettingResponse;
        },
        () => {
            return defaultCertificateSettingResponse;
        },
    );
};

/**
 * 获取 AI 力证书配置
 */
export const getCaetConfig = (): Promise<ICaetSwitchInfo> => {
    return fetchData(
        API.GET_CAET_CONFIG,
        {},
        {
            silent: true,
        },
    ).then((res: IResponse<ICaetSwitchInfo>) => {
        return res?.data || {};
    });
};
